/**
 * generateIdempotencyKey
 *
 * Chave de idempotência client-side: gerada uma vez por tentativa de
 * registro (useCheckin.js / CardioCheckinModal.jsx) e reaproveitada em
 * retries — evita duplicar o check-in quando o POST é reenviado depois de
 * uma falha de rede sem resposta clara (o servidor pode ter processado o
 * registro original antes de a conexão cair, e o cliente não tem como
 * saber). Ver _find_existing_checkin_by_idempotency_key em
 * app/services/user_service.py e docs/07-issues.md.
 *
 * Não precisa ser RFC4122 válido, só suficientemente único por
 * dispositivo/tentativa — crypto.randomUUID() exige contexto seguro
 * (https/localhost); no browser raro sem suporte, cai pra um fallback
 * baseado em timestamp + random.
 */
export function generateIdempotencyKey() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `ck_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}
